<template>
  <div class="cust-service" :class="{'active': showDetail}">
    <div @click="showDetailEvent"  class="cust-service-inner yd-display-flex yd-flexDirection-c yd-alignItems">
      <p>小<br/>锐<br/>客<br/>户</p>
      <img class="kf-arrow" src="../../assets/images/blackArrowLeftIcon.png">
      <img class="yy" src="../../assets/images/yyIcon.png" />
    </div>
    <div class="kf-panel" :class="{'active': showDetail}"></div>
  </div>
</template>

<script>
export default {
  name: "custService",
  data () {
    return {
      showDetail: false
    }
  },
  methods: {
    showDetailEvent () {
      this.showDetail = !this.showDetail
    }
  }
}
</script>

<style scoped>
  .cust-service{
    width: 30px;
    position: fixed;
    top: 50%;
    right: 0;
    z-index: 10;
    background: #fff;
    border-radius: 10px 0 0 10px;
    color: #666666;
    text-align: center;
    box-sizing: border-box;
    padding: 44px 0 8px 0;
    cursor: pointer;
    transition: all 0.5s;
  }
  .cust-service.active{
    right: 100px;
  }
  .cust-service .cust-service-inner p{
    line-height: 20px;
  }
  .cust-service .cust-service-inner img.kf-arrow{
    width: 20px;
    height: 20px;
    margin-top: 2px;
  }
  .cust-service .cust-service-inner .yy{
    width: 33px;
    height: 64px;
    position: absolute;
    top: -9px;
    left: -3px;
  }
  .kf-panel{
    position: absolute;
    top: -5px;
    right: -100px;
    width: 100px;
    height: 200px;
    background: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/custService/index.vue